import React from 'react'
import OptionGroupsComponent from '../components/OptionGroups'
import lang from 'lodash/lang'
import WaiterStepperItemContainer from '../containers/components/WaiterStepperItem'
import * as _ from 'lodash'

window.groupMap = {
  // [group.id]:{[item.id]:item.stepperValue}
}
window.itemGroupMap = {
  // [item.id]:group.id
}
class WaiterOptionGroupsComponent extends OptionGroupsComponent {
  renderWaiterStepperItem (item, currentQty, onAddBtnClick, onMinusBtnClick, shouldShowOverlay) {
    const { merchant } = this.props
    const isSold = _.get(item, 'sold', false) || (merchant.setting.inventory && item.inventory === 0)

    return (
      <WaiterStepperItemContainer
        itemId={item.id}
        name={item.name}
        price={item.price}
        sold={isSold}
        currentQty={currentQty}
        discount={0}
        priceUndetermined={false}
        onAddBtnClick={() => { onAddBtnClick() }}
        onMinusBtnClick={() => { onMinusBtnClick() }}
        shouldShowOverlay={shouldShowOverlay}
      />
    )
  }

  render () {
    const {
      // user,
      // merchant,
      // isTakeaway,
      // classes,
      item,
      groupName,
      groupId,
      inputType,
      dishId,
      // groupMax,
      stashByOptionGroups,
      isMultiple,
    } = this.props

    let filterOptionGroupResult
    let shouldShowOverlay
    let isCurrOptionSelected
    let isAnyGroupOptionSelected
    let currGroup
    let currOption
    // let belowGroupOptionMax
    // let stashedItem

    if (!lang.isEmpty(stashByOptionGroups)) {
      filterOptionGroupResult = stashByOptionGroups.find((group) => {
        return group.groupId === groupId
      })
    }

    if (filterOptionGroupResult) {
      currGroup = filterOptionGroupResult
      isAnyGroupOptionSelected = filterOptionGroupResult.groupOptionQty > 0
      currOption = filterOptionGroupResult.options.find(ele => {
        return ele.id === item.id
      })

      if (currOption) {
        isCurrOptionSelected = true
      } else {
        isCurrOptionSelected = false
      }
    } else {
      isAnyGroupOptionSelected = false
      isCurrOptionSelected = false
    }

    const noGroupOptionMax = !isAnyGroupOptionSelected || (currGroup.groupOptionMax === 0)
    const isOverOptionGroupMax = !noGroupOptionMax && currGroup.groupOptionQty >= currGroup.groupOptionMax
    const noItemMax = !currOption || (currOption.max === 0)
    const belowItemMax = noItemMax || currOption.quantity < currOption.max || currOption.stepperValue < currOption.max
    const isMaxOne = (inputType !== 'stepper') && !noGroupOptionMax && (!isMultiple || currGroup.groupOptionMax === 1)
    const groupOptionQty = currGroup ? currGroup.groupOptionQty : 0
    const itemQty = currOption ? currOption.quantity : 0

    if (isMaxOne) {
      if (isAnyGroupOptionSelected) {
        if (isCurrOptionSelected) {
          shouldShowOverlay = false
        } else {
          shouldShowOverlay = true
        }
      } else {
        shouldShowOverlay = false
      }
    } else {
      if (isOverOptionGroupMax) {
        shouldShowOverlay = true
      } else {
        if (isMultiple) {
          shouldShowOverlay = !belowItemMax
        } else {
          shouldShowOverlay = (!isMultiple && groupOptionQty > 0 && isCurrOptionSelected)
        }
      }
    }

    if (inputType === 'stepper') {
      return (
        <div style={{ width: 'calc(100%/3)', position: 'relative' }}>{
          this.renderWaiterStepperItem(item, itemQty,
            () => {
              if (shouldShowOverlay) {
                return
              }

              item.stepperValue = (itemQty || 0) + 1
              this.onChangeByInputLabel(item, groupName, groupId, dishId, 'stepper', true)
            },
            () => {
              item.stepperValue = (itemQty > 0) ? itemQty - 1 : 0
              this.onChangeByInputLabel(item, groupName, groupId, dishId, 'stepper', false)
            },
            shouldShowOverlay,
          )}
        </div>
      )
    } else {
      // no radio group for waiter
      // checkbox
      if (!isMultiple) {
        // _.set(window.groupMap, `${groupId}.${item.id}`, item.stepperValue || 0)
        window.itemGroupMap[item.id] = groupId
      }

      return (
        <div style={{ width: 'calc(100%/3)', position: 'relative' }}>
          {this.renderWaiterStepperItem(item, isCurrOptionSelected ? 1 : 0,
            () => {
              if (!isMaxOne && shouldShowOverlay) {
                return
              }

              // eslint-disable-next-line no-mixed-operators
              if (isCurrOptionSelected || isCurrOptionSelected && noGroupOptionMax || !isOverOptionGroupMax || isMaxOne) {
                _.set(window.groupMap, `${groupId}.${dishId}`, 1)
                if (isMaxOne) {
                  currGroup.options.forEach(ele => {
                  // remove all item from option group
                    ele.stepperValue = 0
                    this.onChangeByInputLabel(ele, groupName, groupId, ele.id, 'checkbox', false, { target: { checked: false } })
                  })
                  item.stepperValue = 1
                  this.onChangeByInputLabel(item, groupName, groupId, dishId, 'checkbox', true, { target: { checked: true } })
                } else {
                  if (!isCurrOptionSelected) {
                    item.stepperValue = (itemQty || 0) + 1
                    this.onChangeByInputLabel(item, groupName, groupId, dishId, 'checkbox', true, { target: { checked: true } })
                  }
                }
              }
            },
            () => {
              if (isCurrOptionSelected) {
                _.set(window.groupMap, `${groupId}.${dishId}`, 0)
                item.stepperValue = (itemQty > 0) ? itemQty - 1 : 0
                this.onChangeByInputLabel(item, groupName, groupId, dishId, 'checkbox', false, { target: { checked: false } })
              }
            },
            shouldShowOverlay,
          )}
        </div>
      )
    }
  }
}

export default WaiterOptionGroupsComponent



// WEBPACK FOOTER //
// ./src/components/WaiterOptionGroups.js